<template>
  <button
    v-show="visible"
    type="button"
    class="scroll-top"
    aria-label="맨 위로"
    @click="scrollToTop"
  >
    <AppIcon icon="mdi-chevron-up" :size="24" />
  </button>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'

const visible = ref(false)

const onScroll = () => {
  visible.value = window.scrollY > 400
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<style lang="scss" src="./ScrollToTop.scss"></style>
